import ApiServer from "../ApiServer.js";
import * as FwDatas from "../FwDatas.ts";
import {isSameDay} from "../lib/DateUtils.ts";
import * as i18n from "../i18n.ts";
import * as decoders from "../server/decoders_connected.js";
  
var threadByIds = {},threadIdByParticipantKey = {};
Object.assign(ApiServer.types.IIMThread.prototype,{
  participantLine :function(){
    var 
      i,
      builder = "";
      
    for(i=1;i<this.participants.length;i++){
      builder += this.participants[i].accountFirstname+', ';
    }
    builder= builder.substring(0,builder.length-2);
    return builder;
  },
  participantKey:function(){
    return this.participants.slice(1).map(function(o){return o.accountId;}).sort().join(',');
  },
  participantForImgLength :function(){
    return Math.min(4,this.participants.length-1);
  },  
  participantForImg :function(){
    var extraCount,toDisplay = this.participants.filter(function(p,idx){
      return !p.isLogguedAccount;
    });
    if(toDisplay.length>4){
      extraCount = toDisplay.length-3;
      toDisplay.splice(3,extraCount,{avatar:"<span class='"+(extraCount>9?'fw-participant-extra-small':'')+"'>+"+extraCount+"</span>"});
    }
    return toDisplay;
  },
  onDecode(){
    threadIdByParticipantKey[this.participantKey()] = this.metaId;
  }
});
Object.assign(ApiServer.types.IIMParticipant.prototype,{
  avatar:function(){
    return "<img src='"+this.thumb()+"' title='"+this.accountFirstname+"'>";
  }
});
Object.assign(ApiServer.types.IIMMessage.prototype,{
  onDecode(){
    decoders.mapMedia(this);
    decoders.decodeGiphy(this);
    var thread = threadByIds[this.threadId],i,len;
    //a thread just created by the send message will not be in cache
    if(!thread){
      return;
    }
    for(i=0,len=thread.participants.length;i<len;i++){
      var p = thread.participants[i];
      if(p.accountId===this.fromId){
        this.participant = p;
      }
      if(p.isLogguedAccount){
        this.meAsParticipant = p;
      }
    }
    this.isUnread = this.creationDate>this.meAsParticipant.lastReadMessageDate;
    this.accountFirstname = this.participant.accountFirstname;
    this.preview = this.text.match(/https?:\/\/[^\s]*gif/g)?(this.isMe()?i18n.get("im.gifsent"):i18n.getMustache("im.gifreceived",this)):this.text;
  },
  thread:function(){
    return threadByIds[this.threadId];
  },
  author:function(){
    return FwDatas.getProfile(this.fromId).firstName;
  },
  isMe:function(){
    return this.participant.isLogguedAccount;
  }
});
function prepareMessageList(list){
  list.sort(function(a,b){
    return a.creationDate-b.creationDate;
  });
  var prevMessage = list[0],i;
  for(i=1;i<list.length;i++){
    var message = list[i];
    if(message.fromId===prevMessage.fromId){
      message.hideAuthor = true;
      if(message.creationDate-prevMessage.creationDate<60000){
        prevMessage.hideTime = true;
      }
    }else{
      message.hideAuthor = false;
    }
    if(isSameDay(message.creationDate,prevMessage.creationDate)){
      message.hideDate = true;
    }
      
    prevMessage = message;
  }
}

var cachedThread;
function isEquals(threadList1,threadList2){
  if(threadList1.length===threadList2.length){
    for(var i=0;i<threadList2.length;i++){
      if(threadList1[i].messageListModifDate - threadList2[i].messageListModifDate !==0){
        return false;
      }
    }
    return true;
  }
  return false;
}

export function withallthread(isInit,callback){
  //if isInit and something in cache we do it while checking if there is a change
  if(isInit && cachedThread!==undefined){
    callback(cachedThread);
  }
  ApiServer.customimthreadlist(function(threads){
  //sort thread
    threads.sort(function(a,b){
      return b.sortingDate-a.sortingDate;
    });
    
    if(cachedThread!==undefined && isEquals(threads,cachedThread)){
      if(isInit){
        return;
      }else{
        threads = cachedThread;
      }
    }else{
      cachedThread = threads;
    }
    
    
    //store them by id
    threads = threads.map(function(obj){
      var oldThread = threadByIds[obj.metaId];
      threadByIds[obj.metaId] = obj;
      if(oldThread){
        if(oldThread.messageListModifDate==obj.messageListModifDate){
          //keep messages if unchanged
          obj.messages = oldThread.messages;
          obj.lastmessage = oldThread.lastmessage;
        }else{
          //console.log("thread updated")
        } 
      }  
      return obj;
    });
    var idsToUpdate = threads.filter(thread=>thread.messages===undefined).map(function(o){return o.metaId;});
    if(idsToUpdate.length){
      //load last message of each
      ApiServer.immessagelistgrp(idsToUpdate,1,function(list){
        for(var i=0;i<list.length;i++){
          var thread = threadByIds[idsToUpdate[i]];
          thread.messages=list[i];
          thread.lastmessage = thread.messages.datas[0];
        }
        callback(threads);
      });  
    }else{
      callback(threads);
    }
    
    
  });
}
export function withfullthread(threadId,refresh,callback){
  var 
    thread = threadByIds[threadId],
    messages = thread.messages;
  
  if(refresh || (messages.nextPageId!=null &&  messages.datas.length<=1)){
    ApiServer.immessagelist2(threadId, new ApiServer.types.SimplePaginationRequest({count:50}),function(messages){
      thread.lastmessage = messages.datas[0];
      thread.messages = messages;
      prepareMessageList(messages.datas);
      callback(thread);
    });  
  }else{
    callback(thread);
  }
  
}
export function withOlderMessages(threadId,nextPageId,callback){
  ApiServer.immessagelist2(threadId,new ApiServer.types.SimplePaginationRequest({count:50,pageId:nextPageId}),function(messages){
    prepareMessageList(messages.datas);
    //give a fake thread with only asked messages
    callback({messages:messages});
  });  
}
export function withparticipant(participantKey,callback){
  if(typeof participantKey === 'object'){
    participantKey = participantKey.sort().join(',');
  }
  callback(threadIdByParticipantKey[participantKey]);
}